export default __webpack_public_path__ + "static/media/tag-heuer.696af977.png";